import {ChangeDetectionStrategy, Component, ElementRef, HostBinding, HostListener, Inject, OnInit} from '@angular/core';
import {L10N_CONFIG, L10nConfig, L10nLocale, L10nTranslationService} from 'angular-l10n';
import {takeUntil, tap} from 'rxjs/operators';
import {Locale} from '../../enums/language';
import {destroy$} from '../destroyable';
import {DropdownMenuComponent} from '../dropdown-menu';
import {DynamicComponentRef} from '../dynamic-component';
import {ModalService} from '../modal';
import {DISPLAY_LANGUAGE_LIST, LanguageInfo} from '../translate/display-language-list';

@Component({
    selector: 'language-selector',
    templateUrl: 'language-selector.component.html',
    styleUrls: ['language-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LanguageSelectorComponent implements OnInit {

    public locale: L10nLocale = this.translationService.getLocale();

    public languageList: LanguageInfo[] = DISPLAY_LANGUAGE_LIST;
    public currentLang: LanguageInfo = this.getCurrentLangInfo();

    @HostBinding('class.-is-open')
    public dropdownMenu: DynamicComponentRef<DropdownMenuComponent>;

    public readonly destroy$ = destroy$();

    constructor(
        private elementRef: ElementRef,
        private modalService: ModalService,
        private translationService: L10nTranslationService,

        @Inject(L10N_CONFIG)
        private l10nConfig: L10nConfig
    ) {}

    public ngOnInit(): void {
        this.translationService.onChange().pipe(
            tap(locale => this.onLocaleChange(locale)),
            takeUntil(this.destroy$)
        ).subscribe();
    }

    @HostListener('click')
    public openDropdown(): void {
        if (!this.dropdownMenu) {
            this.dropdownMenu = this.modalService.open(DropdownMenuComponent<Locale>, {
                destroyWhen: this.destroy$,
                onDestroy: () => this.dropdownMenu = null,
                configure: {
                    targetElement: this.elementRef,
                    menuItems: this.languageList,
                    onCloseCallback: (value?, item?) =>
                                         this.onCloseDropdownMenu(item as LanguageInfo)
                }
            });
        }
    }

    private getCurrentLangInfo(): LanguageInfo {
        return this.languageList.find(item => item.l10nSchemaLang === this.locale.language);
    }

    private onCloseDropdownMenu(languageInfo?: LanguageInfo): void {
        if (languageInfo) {
            const l10nLocale = this.l10nConfig.schema.find(schemaItem =>
                schemaItem.locale.language === languageInfo.l10nSchemaLang
            );

            if (l10nLocale) {
                this.translationService.setLocale(l10nLocale.locale);
            }
        }
    }

    private onLocaleChange(locale: L10nLocale): void {
        this.locale = locale;

        this.currentLang = this.getCurrentLangInfo();
    }
}
